(function () {
  var SvgChartGlobal = MST;
  var SvgChartMapping = MST.SvgChartMapping;
  var SvgChartDrawUtil = MST.SvgChartDrawUtil;
  var SvgChartUtil = MST.SvgChartUtil;
  var SvgChartProjector = MST.SvgChartProjector;
  var SvgChartTechnical = MST.SvgChartTechnical;
  var SvgChartCache = MST.SvgChartCache;

  var SvgChartScrollView = function (chart) {
    this.chart = chart;
    this.scrollMapping = new SvgChartMapping();
    this.mapping = new SvgChartMapping();

    this.scrollMapping.drawAreaHeight = SvgChartGlobal.LAYOUT_SCROLL_HEIGHT;

    var leftVaxisWidth = 0;
    var rightVaxisWidth = 0;

    this.scrollMapping.setPadding(
      5 + leftVaxisWidth,
      5 + rightVaxisWidth,
      SvgChartGlobal.LAYOUT_PANEL_FRAME_PADDING,
      SvgChartGlobal.LAYOUT_PANEL_FRAME_PADDING +
        SvgChartGlobal.LAYOUT_SCROLL_BAR_HEIGHT
    );

    var scrollConfig = chart.chartConfig.scroll;
    this.scrollMapping.panel = scrollConfig.panel;
    this.scrollMapping.vAxis = scrollConfig.vAxis;
    this.scrollMapping.hAxis = scrollConfig.hAxis;

    this.frameDiv = document.createElement("div");
    this.frameDiv.style.position = "relative";
    this.frameDiv.className = "SvgChartScrollFrame";
    chart.chartDiv.appendChild(this.frameDiv);

    this.actionDiv = document.createElement("div");
    this.frameDiv.appendChild(this.actionDiv);

    this.actionDiv.style.position = "absolute";
    this.actionDiv.style.width = "100%";
    this.actionDiv.style.height = "100%";
    this.actionDiv.style.zIndex = 5;

    this.drawDiv = document.createElement("div");
    this.frameDiv.appendChild(this.drawDiv);

    this.drawDiv.style.position = "absolute";
    this.drawDiv.className = "SvgChartScrollMask";
    this.drawDiv.style.width = "100%";
    this.drawDiv.style.height = "100%";
    this.drawDiv.style.zIndex = 2;

    this.actionCanvasDiv = document.createElement("div");
    this.frameDiv.appendChild(this.actionCanvasDiv);

    this.actionCanvasDiv.style.position = "absolute";
    this.actionCanvasDiv.style.width = "100%";
    this.actionCanvasDiv.style.height = "100%";
    this.actionCanvasDiv.style.zIndex = "1";

    this.axisDiv = document.createElement("div");
    this.frameDiv.appendChild(this.axisDiv);

    this.axisDiv.style.position = "absolute";
    this.axisDiv.style.width = "100%";
    this.axisDiv.style.height = "100%";
    this.axisDiv.style.zIndex = "2";

    this.stoneDiv = document.createElement("div");
    this.frameDiv.appendChild(this.stoneDiv);

    this.stoneDiv.style.position = "absolute";
    this.stoneDiv.style.width = "100%";
    this.stoneDiv.style.height = "100%";
    this.stoneDiv.style.zIndex = 4;

    this.actionAreaDiv = document.createElement("div");
    this.frameDiv.appendChild(this.actionAreaDiv);

    this.actionAreaDiv.style.position = "absolute";
    this.actionAreaDiv.style.width = "100%";
    this.actionAreaDiv.style.height = "100%";
    this.actionAreaDiv.style.zIndex = 3;

    this.scrollDiv = document.createElement("div");
    this.frameDiv.appendChild(this.scrollDiv);

    this.scrollDiv.style.width = "100%";
    this.scrollDiv.style.marginTop = "15px";
    this.scrollDiv.style.height = this.scrollMapping.drawAreaHeight + "px";
    this.scrollDiv.style.zIndex = 1;

    this.scrollDrawCanvas = SvgChartDrawUtil.createCanvas(
      this.drawDiv,
      this.chart.chartWidth,
      this.scrollMapping.drawAreaHeight
    );
    this.scrollActionCanvas = SvgChartDrawUtil.createCanvas(
      this.actionCanvasDiv,
      this.chart.chartWidth,
      this.scrollMapping.drawAreaHeight
    );
    this.scrollAxisCanvas = SvgChartDrawUtil.createCanvas(
      this.axisDiv,
      this.chart.chartWidth,
      this.scrollMapping.drawAreaHeight
    );
    this.scrollStoneCanvas = SvgChartDrawUtil.createCanvas(
      this.stoneDiv,
      this.chart.chartWidth,
      this.scrollMapping.drawAreaHeight
    );
    this.scrollActionAreaCanvas = SvgChartDrawUtil.createCanvas(
      this.actionAreaDiv,
      this.chart.chartWidth,
      this.scrollMapping.drawAreaHeight
    );

    var util = new SvgChartUtil();
    util.attachTouchEventOld(this, this.actionDiv);
    this.actionDiv.className = "SvgChartActionView";
    this.actionDiv.style.cursor = "pointer";
  };

  SvgChartScrollView.prototype.drawstoneDiv = function (div, w, h) {
    var context = SvgChartDrawUtil.createCanvas(div, w, h);
    var y0 = this.scrollMapping.paddingTop + 0.5;
    var x = Math.round(w / 2) + 0.5;
    var y = Math.round((h - SvgChartGlobal.LAYOUT_SCROLL_BAR_HEIGHT) / 2) - 1.5;
    SvgChartDrawUtil.line(
      context,
      x,
      y0,
      x,
      h - y0,
      SvgChartGlobal.COLOR_SCROLL_DRAG_LINE
    );
    var r = SvgChartDrawUtil.fillRect(
      context,
      x - 4,
      y - 7,
      8,
      14,
      SvgChartGlobal.COLOR_SCROLL_DRAG_LINE,
      SvgChartGlobal.COLOR_SCROLL_STONE_BKGND
    );
    SvgChartDrawUtil.line(
      context,
      x - 1,
      y - 4,
      x - 1,
      y + 4,
      SvgChartGlobal.COLOR_SCROLL_DRAG_LINE
    );
    SvgChartDrawUtil.line(
      context,
      x + 1,
      y - 4,
      x + 1,
      y + 4,
      SvgChartGlobal.COLOR_SCROLL_DRAG_LINE
    );
    return r;
  };

  SvgChartScrollView.prototype.drawstone = function (x, active) {
    var context = this.scrollStoneCanvas;
    var y0 = this.scrollMapping.paddingTop - 0.5;
    var h =
      this.scrollMapping.drawAreaHeight -
      SvgChartGlobal.LAYOUT_SCROLL_BAR_HEIGHT;
    var y = Math.round(h / 2) - 1.5;

    var fillColor = SvgChartGlobal.COLOR_SCROLL_STONE_BKGND;
    var lineColor = SvgChartGlobal.COLOR_SCROLL_DRAG_LINE;
    if (active) {
      fillColor = SvgChartGlobal.COLOR_SCROLL_STONE_BKGND_ACTION;
      lineColor = SvgChartGlobal.COLOR_SCROLL_DRAG_LINE_ACTION;
    }

    SvgChartDrawUtil.line(
      context,
      x,
      y0 - 1,
      x,
      h - 1,
      SvgChartGlobal.COLOR_SCROLL_DRAG_LINE
    );
    // SvgChartDrawUtil.fillRect(context, x - 4, y - 7, 8, 14, SvgChartGlobal.COLOR_SCROLL_DRAG_LINE, fillColor);

    var d = "M " + (x - 4) + ", " + (y - 10);
    d += "L " + (x - 4) + ", " + (y + 10);
    // d += "A 4,3,0,0,0," + (x + 4) + ", " + (y + 6);
    d += "L " + (x + 4) + ", " + (y + 10);
    d += "L " + (x + 4) + ", " + (y - 10);
    // d += "A 4,3,0,0,0," + (x - 4) + ", " + (y - 6);
    d += "L " + (x - 4) + ", " + (y - 10);
    SvgChartDrawUtil.pathFill(
      context,
      d,
      1,
      SvgChartGlobal.COLOR_SCROLL_DRAG_LINE,
      fillColor
    );
  };

  SvgChartScrollView.prototype.chart = null;
  SvgChartScrollView.prototype.mapping = null;
  SvgChartScrollView.prototype.scrollMapping = null;
  SvgChartScrollView.prototype.scrollDiv = null;
  SvgChartScrollView.prototype.frameDiv = null;
  SvgChartScrollView.prototype.actionDiv = null;
  SvgChartScrollView.prototype.axisDiv = null;
  SvgChartScrollView.prototype.actionCanvasDiv = null;
  SvgChartScrollView.prototype.scrollDrawCanvas = null;
  SvgChartScrollView.prototype.scrollActionCanvas = null;
  SvgChartScrollView.prototype.scrollAxisCanvas = null;
  SvgChartScrollView.prototype.scrollActionStatus = null;
  SvgChartScrollView.prototype.stoneDivLeft = null;
  SvgChartScrollView.prototype.stoneDivRight = null;
  SvgChartScrollView.prototype.stoneLeft = null;
  SvgChartScrollView.prototype.stoneRight = null;
  SvgChartScrollView.prototype.stoneLeftActive = false;
  SvgChartScrollView.prototype.stoneRightActive = false;

  SvgChartScrollView.prototype.drawActionArea = function () {
    // console.log("========SvgChartScrollView draw start===========");

    var startIndex = Math.min(0, this.mapping.dataStartIndex);
    this.scrollMapping.setDataRange(
      startIndex,
      this.chart.mainTechnical.data.length - startIndex
    );

    var projector = new SvgChartProjector();
    this.mapping = this.chart.mainMapping;

    if (this.chart.mainMapping.benchmark == false) {
      var dividendSum = 0;
      var cacheData = SvgChartCache.load(this.chart.mainTechnical.dataLoadUrl);

      if (cacheData != null) {
        // var target = [];
        var target = {};

        for (var i = 0; i < cacheData.data.length; i++) {
          // target.push(cacheData.data[i]);
          target[cacheData.data[i][0]] = cacheData.data[i][2];
        }

        var dividendSum = 0;

        for (
          var i = this.mapping.dataStartIndex;
          i < this.mapping.dataStartIndex + this.mapping.dataLength;
          i++
        ) {
          if (this.chart.mainTechnical.data[i] == null) continue;

          if (
            target[new Date(this.chart.mainTechnical.data[i].date).getTime()] !=
            null
          ) {
            dividendSum += Number(
              target[new Date(this.chart.mainTechnical.data[i].date).getTime()]
            );
          }

          if (this.chart.mainTechnical.data[i].close != null) {
            this.chart.mainTechnical.data[i].dividend =
              this.chart.mainTechnical.data[i].close + dividendSum;
          }
        }
      }
    }

    this.scrollMapping.setDataMinMax(
      this.chart.mainMapping.dataMinValue,
      this.chart.mainMapping.dataMaxValue
    );
    projector.updateDataMinMax([this.chart.mainTechnical], this.scrollMapping);

    SvgChartDrawUtil.clear(this.scrollActionAreaCanvas);
    projector.projectAxis(this.scrollActionAreaCanvas, this.scrollMapping, -1);
    projector.projectAreaScroll(
      this.scrollActionAreaCanvas,
      [this.chart.mainTechnical],
      this.scrollMapping,
      this.mapping
    );
  };

  SvgChartScrollView.prototype.draw = function () {
    // console.log("========SvgChartScrollView draw start===========");

    var startIndex = Math.min(0, this.mapping.dataStartIndex);
    this.scrollMapping.setDataRange(
      startIndex,
      this.chart.mainTechnical.data.length - startIndex
    );

    this.scrollMapping.setPadding(
      5 - this.scrollMapping.getUnitWidth() / 2,
      5 - this.scrollMapping.getUnitWidth() / 2,
      this.scrollMapping.paddingTop,
      this.scrollMapping.paddingBottom
    );
    var projector = new SvgChartProjector();
    this.mapping = this.chart.mainMapping;

    if (this.chart.mainMapping.benchmark == false) {
      var dividendSum = 0;
      var cacheData = SvgChartCache.load(this.chart.mainTechnical.dataLoadUrl);

      if (cacheData != null) {
        // var target = [];
        var target = {};

        for (var i = 0; i < cacheData.data.length; i++) {
          // target.push(cacheData.data[i]);
          target[cacheData.data[i][0]] = cacheData.data[i][2];
        }

        var dividendSum = 0;

        for (
          var i = this.mapping.dataStartIndex;
          i < this.mapping.dataStartIndex + this.mapping.dataLength;
          i++
        ) {
          if (this.chart.mainTechnical.data[i] == null) continue;

          if (
            target[new Date(this.chart.mainTechnical.data[i].date).getTime()] !=
            null
          ) {
            dividendSum += Number(
              target[new Date(this.chart.mainTechnical.data[i].date).getTime()]
            );
          }

          if (this.chart.mainTechnical.data[i].close != null) {
            this.chart.mainTechnical.data[i].dividend =
              this.chart.mainTechnical.data[i].close + dividendSum;
          }
        }
      }
    }

    this.scrollMapping.setDataMinMax(
      this.chart.mainMapping.dataMinValue,
      this.chart.mainMapping.dataMaxValue
    );
    projector.updateDataMinMax([this.chart.mainTechnical], this.scrollMapping);

    var hAxisValues = new Array();

    var timeFormat = SvgChartUtil.getTimeFormat(this.chart.period, "all");

    var label = timeFormat(new Date());
    var labelWidth = SvgChartUtil.measureText(this.chart, label);
    var labelGap = Math.ceil(
      (labelWidth + 30) / this.scrollMapping.getUnitWidth()
    );
    var rightGap = Math.max(
      Math.ceil(
        (labelWidth / 2 - this.scrollMapping.paddingRight) /
          this.scrollMapping.getUnitWidth()
      ),
      0
    );
    var leftGap = Math.max(
      Math.ceil(
        (labelWidth / 2 - this.scrollMapping.paddingLeft) /
          this.scrollMapping.getUnitWidth()
      ),
      0
    );

    var lastIndex = this.chart.mainTechnical.data.length - 1;
    var prevIndex = lastIndex + labelGap;

    for (
      var i =
        this.scrollMapping.dataStartIndex +
        this.scrollMapping.dataLength -
        1 -
        rightGap;
      i >= this.scrollMapping.dataStartIndex + leftGap - 1 && i >= 0;
      i--
    ) {
      var label = timeFormat(this.chart.mainTechnical.data[i].date);
      var labelPrev =
        i > 0 ? timeFormat(this.chart.mainTechnical.data[i - 1].date) : "";

      if (label != labelPrev && prevIndex - i >= labelGap) {
        hAxisValues.push({ value: i, label: label });
        prevIndex = i;
      }
    }
    this.scrollMapping.setHAxisValues(hAxisValues);

    SvgChartDrawUtil.clear(this.scrollAxisCanvas);
    SvgChartDrawUtil.clear(this.scrollDrawCanvas);

    this.drawScrollAction();
  };

  SvgChartScrollView.prototype.hitTestScroll = function (x, y) {
    var extendSpace = 0;

    var x0 = this.scrollMapping.transformIndex(this.mapping.dataStartIndex);
    var x1 = this.scrollMapping.transformIndex(
      this.mapping.dataStartIndex + this.mapping.dataLength - 1
    );
    // var y0 = this.scrollMapping.drawAreaHeight + this.scrollMapping.paddingBottom / 2;
    var h =
      this.scrollMapping.drawAreaHeight -
      SvgChartGlobal.LAYOUT_SCROLL_BAR_HEIGHT;
    var y0 = Math.round(h / 2) - 1.5;
    var y1 = y0 - 15;
    var y2 = y0 + 15;
    var x2 = (x0 + x1) / 2;

    if (x <= x1 && x >= x0 && y > y0) {
      return "dragmiddle";
    }

    // if (x < x2 && x < x0 + SvgChartGlobal.LAYOUT_SCROLL_DRAG_WIDTH / 2 && x > x0 - SvgChartGlobal.LAYOUT_SCROLL_DRAG_WIDTH / 2) {
    if (
      x < x0 + SvgChartGlobal.LAYOUT_SCROLL_DRAG_WIDTH / 2 + extendSpace &&
      x > x0 - SvgChartGlobal.LAYOUT_SCROLL_DRAG_WIDTH / 2 - extendSpace
    ) {
      if (y > y1 && y < y2) {
        return "dragleft";
      }
      // } else if (x >= x2 && x < x1 + SvgChartGlobal.LAYOUT_SCROLL_DRAG_WIDTH / 2 && x > x1 - SvgChartGlobal.LAYOUT_SCROLL_DRAG_WIDTH / 2) {
    } else if (
      x < x1 + SvgChartGlobal.LAYOUT_SCROLL_DRAG_WIDTH / 2 + extendSpace &&
      x > x1 - SvgChartGlobal.LAYOUT_SCROLL_DRAG_WIDTH / 2 - extendSpace
    ) {
      if (y > y1 && y < y2) {
        return "dragright";
      }
    } else if (
      x >= x0 + SvgChartGlobal.LAYOUT_SCROLL_DRAG_WIDTH / 2 &&
      x <= x1 - SvgChartGlobal.LAYOUT_SCROLL_DRAG_WIDTH / 2
    ) {
      return "dragmiddle";
    } else {
      return "moveto";
    }
  };

  SvgChartScrollView.prototype.onTouchEvent = function (
    target,
    pharse,
    cursorCoords
  ) {
    if (
      this.chart.actionView.mapping.status != SvgChartTechnical.DATA_STATUS_OK
    ) {
      return true;
    }

    return this.onScrollTouchEvent(pharse, cursorCoords);
  };

  SvgChartScrollView.prototype.onScrollTouchEvent = function (
    pharse,
    cursorCoords
  ) {
    if (this.chart.period == "5m") return;

    var preventDefault = false;

    var x, y;

    if (cursorCoords != null) {
      x = cursorCoords.x;
      y = cursorCoords.y;
    }
    var needUpdate = false;

    if (pharse == "touchstart") {
      var hittest = this.hitTestScroll(x, y);

      if (hittest == "moveto") {
        var toIndex = Math.round(
          this.scrollMapping.unTransformIndex(x) - this.mapping.dataLength / 2
        );

        var startIndexMin = this.scrollMapping.dataStartIndex;
        var startIndexMax =
          this.chart.mainTechnical.data.length - this.mapping.dataLength;

        var startIndex = Math.max(
          startIndexMin,
          Math.min(toIndex, startIndexMax)
        );

        this.mapping.setDataRange(startIndex, this.mapping.dataLength);

        needUpdate = true;
      } else if (hittest != null) {
        // preventDefault = true;

        this.scrollActionStatus = {
          type: hittest,
          x: x,
          y: y,
          dataStartIndex: this.mapping.dataStartIndex,
          dataLength: this.mapping.dataLength,
        };
        // this.drawScrollAction();
      }

      if (
        window.current_scrolling_target == undefined ||
        window.current_scrolling_target == null
      ) {
        window.current_scrolling_target = this;
      }
    } else if (pharse == "touchmove") {
      // console.log("========  touchmove  ===========");
      if (this.scrollActionStatus != null) {
        preventDefault = true;

        var offset = Math.round(
          this.scrollMapping.unTransformIndex(x) -
            this.scrollMapping.unTransformIndex(this.scrollActionStatus.x)
        );

        var dataStartIndexLast = this.mapping.dataStartIndex;
        var dataLengthLast = this.mapping.dataLength;
        if (this.scrollActionStatus.type == "dragleft") {
          var startIndexMin = this.scrollMapping.dataStartIndex;
          var startIndexMax =
            this.scrollActionStatus.dataStartIndex +
            this.scrollActionStatus.dataLength -
            this.chart.minPageLength;

          var startIndex = Math.max(
            startIndexMin,
            Math.min(
              this.scrollActionStatus.dataStartIndex + offset,
              startIndexMax
            )
          );
          var length =
            this.scrollActionStatus.dataStartIndex +
            this.scrollActionStatus.dataLength -
            startIndex;

          this.mapping.setDataRange(startIndex, length);
        } else if (this.scrollActionStatus.type == "dragright") {
          var lengthMin = Math.max(
            this.chart.minPageLength,
            -this.scrollActionStatus.dataStartIndex + 1
          );
          var lengthMax =
            this.chart.mainTechnical.data.length -
            this.scrollActionStatus.dataStartIndex;

          var length = Math.max(
            lengthMin,
            Math.min(this.scrollActionStatus.dataLength + offset, lengthMax)
          );

          this.mapping.setDataRange(
            this.scrollActionStatus.dataStartIndex,
            length
          );
        } else if (this.scrollActionStatus.type == "dragmiddle") {
          var startIndexMin = Math.max(
            this.scrollMapping.dataStartIndex,
            -this.scrollActionStatus.dataLength + 1
          );
          var startIndexMax =
            this.chart.mainTechnical.data.length -
            this.scrollActionStatus.dataLength;

          var startIndex = Math.max(
            startIndexMin,
            Math.min(
              this.scrollActionStatus.dataStartIndex + offset,
              startIndexMax
            )
          );

          this.mapping.setDataRange(
            startIndex,
            this.scrollActionStatus.dataLength
          );
        }

        if (
          dataStartIndexLast != this.mapping.dataStartIndex ||
          dataLengthLast != this.mapping.dataLength
        ) {
          if (Raphael.svg) {
            needUpdate = true;
          } else {
            this.drawScrollAction();
          }
        }
      }
    } else if (pharse == "touchend") {
      this.actionDiv.style.cursor = "pointer";
      if (this.scrollActionStatus != null) {
        // preventDefault = true;

        this.scrollActionStatus = null;
        // this.drawScrollAction();
        needUpdate = true;
      }
    }

    this.stoneLeftActive = false;
    this.stoneRightActive = false;
    var hittest = this.hitTestScroll(x, y);
    if (hittest == "dragleft") {
      this.actionDiv.style.cursor = "e-resize";
      this.stoneLeftActive = true;
    } else if (hittest == "dragright") {
      this.actionDiv.style.cursor = "e-resize";
      this.stoneRightActive = true;
    } else if (hittest == "dragmiddle") {
      this.actionDiv.style.cursor = "pointer";
      this.stoneLeftActive = true;
      this.stoneRightActive = true;
    } else {
      this.actionDiv.style.cursor = "pointer";
    }
    if (pharse == "touchout") {
      this.actionDiv.style.cursor = "pointer";
      this.stoneLeftActive = false;
      this.stoneRightActive = false;
    }

    if (needUpdate) {
      this.chart.setDataRange(
        this.mapping.dataStartIndex,
        this.mapping.dataLength
      );
    } else {
      this.drawScrollAction();
    }

    return !preventDefault;
  };

  SvgChartScrollView.prototype.drawScrollAction = function () {
    // console.log("========  drawScrollAction  ===========" + new Date());
    // Get context
    // var context = this.scrollActionCanvas;

    // Clear it
    SvgChartDrawUtil.clear(this.scrollActionCanvas);
    SvgChartDrawUtil.clear(this.scrollStoneCanvas);

    // Project technicals
    if (this.mapping.status == SvgChartTechnical.DATA_STATUS_OK) {
      var y0 = this.scrollMapping.paddingTop - 1.5;
      var y1 =
        this.scrollMapping.drawAreaHeight -
        this.scrollMapping.paddingBottom +
        0.5;
      // var x0 = this.scrollMapping.transformIndex(Math.max(0, this.mapping.dataStartIndex)) - 1;
      var x0 =
        this.scrollMapping.transformIndex(this.mapping.dataStartIndex) + 0.5;
      var x1 =
        this.scrollMapping.transformIndex(
          this.mapping.dataStartIndex + this.mapping.dataLength - 1
        ) + 0.5;

      if (this.chart.rangeView != null) {
        this.chart.rangeView.setDataRange(
          this.mapping.dataStartIndex,
          this.mapping.dataLength
        );
      }

      y1 += 1;
      var y2 = this.scrollMapping.drawAreaHeight - 1.5;

      this.drawstone(x0, this.stoneLeftActive);
      this.drawstone(x1, this.stoneRightActive);

      this.drawActionArea();

      SvgChartDrawUtil.line(
        this.scrollStoneCanvas,
        0.5,
        1.5,
        x0 + 0.5,
        1.5,
        SvgChartGlobal.COLOR_SCROLL_DRAG_LINE
      );
      SvgChartDrawUtil.line(
        this.scrollStoneCanvas,
        x1 - 0.5,
        1.5,
        this.scrollMapping.drawAreaWidth + 0.5,
        1.5,
        SvgChartGlobal.COLOR_SCROLL_DRAG_LINE
      );

      SvgChartDrawUtil.line(
        this.scrollStoneCanvas,
        x0,
        y1,
        x1,
        y1,
        SvgChartGlobal.COLOR_SCROLL_DRAG_LINE
      );
    }
  };

  MST.SvgChartScrollView = SvgChartScrollView;
})();
